export default {
  disconnect: 'disconnect',
  clientUnknown: 'client unknown',
  orderUpdated: 'order updated',
  tableStatus: 'order status',
  tableInfo: 'table info',
  basketRequest: 'basket request',
  basketStatus: 'basket status',
  basketUpdate: 'update basket',
  submitBasket: 'submit basket',
  changeState: 'change state',
  currentState: 'current state',
  reviewOrder: 'review order',
  menuPage: 'menu page',
  closeMenu: 'go back',
  createIntent: 'pay in full',
  submitTip: 'submit tip',
  submitDonation: 'submit donation',
  submitSplitBillEvenly: 'submit split bill evenly',
  retryPayment: 'retry payment',
  paymentIntent: 'payment intent',
  paymentResult: 'payment result',
  sendEmail: 'send email',
  backToOrderList: 'go back',
  paymentOptions: 'payment options',
  splitBill: 'split bill',
  splitByItems: 'split by items',
  splitByAmount: 'split by amount',
  splitBillEvenly: 'split bill evenly',
  splitByPercentage: 'split by percentage',
  provisionalPartPayment: 'submit part payment',
  getGiftCardBalance: 'get gift card balance',
  useGiftCard: 'use gift card',
  closeGiftCardModal: 'close gift card modal',
  removeGiftCard: 'remove gift card',
  completeGiftCardPayment: 'complete gift card payment',
  paymentSubmitted: 'payment submitted',
  pdqPaymentMessage: 'PDQ payment message',
  pdqPaymentSubmitted: 'PDQ payment submitted',
  pdqPaymentFailed: 'DNA Payment Failed',
  redundantConnection: 'redundant connection',
  orderMore: 'order more',
  leaveTable: 'leave table',
  appError: 'app error',
  updateSplitByItemBill: 'update split by item bill',
  submitSplitByItemBill: 'submit split by item bill',
  loyaltyPage: 'loyalty page',
  submitLoyaltyNumber: 'submit loyalty number',
  submitFailedComtrexPayments: 'submit failed comtrex payments',
};
